import { FormFieldValueGroupUI } from "Backend";
import { Cell } from "generated/graphql";
import { compareCellValues } from "./compareCellValues";

export function sortValueGroups(
  localValueGroups: (FormFieldValueGroupUI | undefined)[],
  dir: "asc" | "desc",
  cell: Cell
): (FormFieldValueGroupUI | undefined)[] {
  const sortedValueGroups = localValueGroups.slice();
  sortedValueGroups.sort((a, b) => {
    const aCellValue = a?.values.find((v) => v.cellId === cell.id);
    const bCellValue = b?.values.find((v) => v.cellId === cell.id);
    return compareCellValues(aCellValue?.value, bCellValue?.value, dir);
  });
  return sortedValueGroups;
}
